import easyfyAxios from '@shared/easyfy.axios';

export const GetPlacements = async (data: GetPlacementsRequest): Promise<any> => {
  return await easyfyAxios.post('/api/mediaPlacements', data);
};

export interface GetPlacementsRequest {
  decisionApiRequest: DecisionApiRequest;
  containers: Container[];
}

export interface DecisionApiRequest {
  user: User;
  consent: Consent;
  placements: Placement[];
  keywords: string[];
  url: string;
}

export interface User {
  key: string;
}

export interface Consent {
  gdpr: boolean;
}

export interface Placement {
  divName: string;
  adTypes: number[];
  zoneIds?: number[];
  count: number;
}

export interface Container {
  listName: string;
  divName: string;
  productCardType: number;
  isSlider: boolean;
}

export interface KevelPlaceholder {
  listName: string;
  divName: string;
  productCardType: number;
  adTypes: number[];
  zones?: number[];
  count: number;
  keywords: string[];
  element: HTMLElement;
  isSlider: boolean;
}

export interface RenderedProductCardsResponse {
  productCards: RenderedProductCardsCollection[];
  eventLayer: any;
}

export interface RenderedProductCardsCollection {
  containerId: string;
  partials: string[];
  isSlider: boolean;
}
